export var IDENTIFIER_TABLE = 'table';
export var IDENTIFIER_TABLE_ROW = 'table-row';
export var IDENTIFIER_TABLE_CELL = 'table-cell';
